<template>
  <div>
      <div class="appVersion" style="margin-bottom: 1rem">
          <div class="header">
              <div class="right">
                  <a-space>
                      <button class="btn btn-primary" type="primary" @click="add">
                          <span>➕</span>
                          <span>新增</span>
                      </button>
                  </a-space>
              </div>
          </div>
      </div>
      <Tablelist
              :showCheckbox="false"
              :list="dataDict"
              :columns="tableColumns"
              @action="handleAction"
      >
          <template v-slot:actions="{ item }">
              <a-space>
                  <a href="#" @click.prevent="edit(item)">编辑</a>
                  <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
              </a-space>
          </template>
      </Tablelist>
      <Modal v-if="visible" v-model="visible"
             :visible="visible"
             :title="editingText?'编辑数据字典':'新增数据字典'"
             :showFooter="false"
             :overlayOpacity="0.5"
             @update:visible="visible = $event">
        <Edit @cancel="cancel" :text="editingText" />
      </Modal>
  </div>
</template>

<script>
import { remove } from "@/api/setting/data-dict";
import { mapActions, mapState } from "vuex";
import Edit from "./edit.vue";
export default {
  components: {
    Edit,
  },

  data() {
    return {
      loading: false,
      rawList: [
        {id: '1',name: '键1',value: '值1',icon: 'icon1.png',sort: 1,},
        {id: '2',name: '键2',value: '值2',icon: 'icon2.png',sort: 2,},
        {id: '3',name: '键3',value: '值3',icon: 'icon3.png',sort: 3,}
      ],
      visible: false,
      editingText: {
        name: "",
        id: "",
        value: "",
      },
      tableColumns: [
        {
            key: 'name',
            title: '键',
            field: 'name'
        },
        {
            key: 'value',
            title: '值',
            field: 'value',
            ellipsis: true
        },
        {
            key: 'icon',
            title: '图标',
            field: 'icon',
            ellipsis: true
        },
        {
            key: 'sort',
            title: '排序',
            field: 'sort',
            ellipsis: true
        },
        {
            key: 'actions',
            title: '操作',
            field:'actions',
            infotype: 'template'
        }
      ]
    };
  },

  computed: {
    ...mapState("setting", ["dataDict"]),
  },

  mounted() {
    this.getList();
  },

  methods: {
    ...mapActions("setting", ["getDataDict"]),
      handleAction(actionInfo) {
          const { type, item } = actionInfo;
          switch(type) {
              case 'edit':
                  this.edit(item);
                  break;
              case 'delete':
                  this.deleteText(item);
                  break;
          }
      },
    getList() {
      this.loading = true;

      this.getDataDict().finally(() => {
        this.loading = false;
      });
    },

    add() {
      this.editingText = {};
      this.visible = true;
    },

    edit(text) {
      this.editingText = text;
      this.visible = true;
    },

    cancel() {
      this.visible = false;
      this.getList();
    },

    deleteText(text) {
      const that = this;

      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>